/// Nulo passa tudo; com id, passa só quem tem aquela tag.
export function matchesTag(tags: { id: string }[] | null | undefined, filter: string | null): boolean {
    if (filter === null) return true;

    return (tags ?? []).some((tag) => tag.id === filter);
}
